export default {"src":"/_next/static/media/heart-plus.33b46cbc.svg","height":42,"width":51,"blurWidth":0,"blurHeight":0};